import React from 'react';
import './Header.css'
import Logo from "../Logo/Logo";
import Nav from "../NavLink/Nav";

const Header = () => {
    return (
        <div className="header">
            <Logo/>
            <Nav/>
            <div className="version">Версия: 1.0</div>
        </div>
    );
};

export default Header;